
import { useState, useEffect } from 'react';

type ConsentStatus = 'pending' | 'accepted' | 'rejected';

export default function CookieBanner() {
  const [consentStatus, setConsentStatus] = useState<ConsentStatus>('pending');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const savedConsent = localStorage.getItem('cookie-consent');
    if (savedConsent === 'accepted') {
      setConsentStatus('accepted');
      enableAnalytics();
    } else if (savedConsent === 'rejected') {
      setConsentStatus('rejected');
    } else {
      // Kurze Verzögerung für sanftes Einblenden
      setTimeout(() => setIsVisible(true), 500);
    }
  }, []);

  const enableAnalytics = () => {
    // Google Analytics aktivieren
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('consent', 'update', {
        analytics_storage: 'granted',
      });
    }
  };

  const disableAnalytics = () => {
    // Google Analytics deaktivieren
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('consent', 'update', {
        analytics_storage: 'denied',
      });
    }
  };

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setConsentStatus('accepted');
    enableAnalytics();
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookie-consent', 'rejected');
    setConsentStatus('rejected');
    disableAnalytics();
    setIsVisible(false);
  };

  const handleSettings = () => {
    // Öffnet die Datenschutzseite
    window.REACT_APP_NAVIGATE('/datenschutz');
  };

  // Banner nicht anzeigen, wenn bereits entschieden
  if (consentStatus !== 'pending') return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-500 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}
    >
      {/* Overlay für Mobile */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none md:hidden" />
      
      <div className="bg-white border-t border-gray-200 shadow-2xl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-5">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            {/* Text */}
            <div className="flex items-start gap-3 flex-1">
              <div className="w-10 h-10 flex items-center justify-center bg-teal/10 rounded-lg flex-shrink-0 mt-0.5">
                <i className="ri-cookie-line text-teal text-xl"></i>
              </div>
              <div>
                <h3 className="text-base font-semibold text-navy mb-1">
                  Cookie-Einstellungen
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Wir nutzen Cookies, um unsere Website zu verbessern und Ihren Besuch zu analysieren. 
                  Mit Ihrer Zustimmung helfen Sie uns, Hund-im-Alter noch besser zu machen.{' '}
                  <button
                    onClick={handleSettings}
                    className="text-teal hover:text-teal-light underline cursor-pointer whitespace-nowrap"
                  >
                    Mehr erfahren
                  </button>
                </p>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 lg:flex-shrink-0">
              <button
                onClick={handleReject}
                className="px-5 py-2.5 text-sm font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap hover:scale-105"
              >
                Nur notwendige
              </button>
              <button
                onClick={handleAccept}
                className="px-5 py-2.5 text-sm font-medium text-white bg-teal hover:bg-teal-light rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap hover:scale-105 shadow-md hover:shadow-lg"
              >
                Alle akzeptieren
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
